/**
 * Form-factor selection (SPEC §1A.2): one responsive codebase decides the layout by width, with a
 * user override in Settings.
 */

export type FormFactor = "desktop" | "tablet" | "mobile";
export type FormFactorOverride = FormFactor | "auto";

export const BREAKPOINTS = { desktop: 1024, tablet: 768 } as const;

export function formFactorForWidth(width: number): FormFactor {
  if (width >= BREAKPOINTS.desktop) return "desktop";
  if (width >= BREAKPOINTS.tablet) return "tablet";
  return "mobile";
}

export function resolveFormFactor(width: number, override: FormFactorOverride): FormFactor {
  return override === "auto" ? formFactorForWidth(width) : override;
}
